import {MyopMessages} from "../../common/MyopMessages";
import {myopAttributes} from "../../consts";
import {BaseMessageHandler} from "../../common";
import {ElementValueReplayMessage, FormDataEntry, GetElementValueMessage, InputElementValue,} from "../../messages";
import {makeSerializable} from "../../common/utils/serialization.ts";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

const getInputValue = (element): InputElementValue => {
    if (!element) return null;

    // Check if it's a form
    if (element.tagName === 'FORM') {
        const formData = new FormData(element);
        const dataObject: InputElementValue = {
            formData: {},
            unmappedData: []
        };

        // Manually add elements without names
        const elements = element.querySelectorAll('input, select, textarea');
        let autoNameIndexer = -1;

        elements.forEach(element => {
            if (typeof element.value === 'string') {
                const myopId = element.getAttribute(myopAttributes.id);
                let key = element.getAttribute('name');

                // `_${(++autoNameIndexer)}`

                const nodeData: FormDataEntry = {
                    id: element.id,
                    name: key,
                    value: getInputValue(element),
                    required: element.required,
                    validity: makeSerializable(element.validity, true),
                    myopId,
                };


                dataObject.unmappedData!.push(nodeData);
                if (key) {
                    if(!dataObject.formData![key] || !dataObject.formData![key].value || nodeData.value){
                        dataObject.formData![key] = nodeData
                    }
                }
                //
                // if (!key) {
                //     dataObject.unmappedData!.push(nodeData);
                // } else {
                //     if (dataObject.formData![key]) {
                //         if (dataObject.formData![key].value) {
                //             dataObject.unmappedData!.push(nodeData);
                //         } else {
                //             dataObject.unmappedData!.push(dataObject.formData![key]);
                //             dataObject.formData![key] = nodeData
                //         }
                //     } else {
                //         dataObject.formData![key] = nodeData
                //     }
                // }
            }
        });

        return dataObject;
    }

    // Check if it's a checkbox or radio button
    if (element.type === 'checkbox' || element.type === 'radio') {
        return element.checked ? element.value : null;
    }

    // Handle input and textarea elements
    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
        return element.value;
    }

    // Handle select elements (dropdowns)
    if (element.tagName === 'SELECT') {
        return element.value;
    }

    // Handle editable divs (contentEditable)
    if (element.isContentEditable) {
        return element.innerText || element.textContent;
    }

    // If it's an unsupported element type
    return null;
}

export class GetElementValueHandler extends BaseMessageHandler<GetElementValueMessage> {

    messageType = MyopMessages.GetElementValueMessage;

    executor = (event: GetElementValueMessage) => {
        const items = getElementsByRef(event.ref, document);
        items.forEach(item => {
            // @ts-ignore
            this.messageToHost(new ElementValueReplayMessage(
                getInputValue(item)
            ), event);
        })
    }
}
